import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getCategories } from '../api/services/api'

export const Route = createFileRoute('/categories')({
  component: Categories,
})

function Categories() {
  const { data, isLoading } = useQuery({
    queryKey: ['categories'],
    queryFn: () => getCategories(),
  })
  return (
    <div>
      {isLoading ? 'Loading...' : 'Categories'}
      {data?.items.map((category) => {
        return <div key={category.id}>{category.name}</div>
      })}
    </div>
  )
}
